jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        var res = [];
        res.init = false;
        res.pages = false;
        var rhr = null;

        $(window).on('load', function(){
            resourcesInit();
        });

        function resourcesInit(){
            if ($('#res-filter').length>0) {
                $('#res-filter select').on('change', function() {
                    resourcesAjaxSearch();
                });
                $('#res-filter select').on('keydown', function(e) {
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        resourcesAjaxSearch();
                        return false;
                    }
                });
                $('#res-filter button').click(function(e) {
                    e.preventDefault();
                    resourcesAjaxSearch();
                    return false;
                });
                resourcesAjaxSearch();
                $('body').on('click', '.res-ajax-nav .ajax-nav', function(e){
                    e.preventDefault();
                    if (res.pages != false) {
                        var pages = res.pages
                        var current = parseInt($('.res-ajax-nav').attr('data-current')),
                            page = current;

                        if ($(this).hasClass('prev')) {
                            page = current - 1;
                            if (current < 0) {
                                page = 0;
                            }
                        }
                        else {
                            page = current + 1;
                            var total = parseInt($('.res-ajax-nav').attr('data-total'));
                            if (page > total) {
                                page = total;
                            }
                        }
                        var ids = pages[page];
                        if (ids != undefined && page != current) {
                            getResPage(ids);
                            $('.res-ajax-nav').attr('data-current', page);
                            $('#current_res_page').text(page + 1);
                        }
                    }
                });
            }
            res.init = true;
        }

        setTimeout(function(){
            if (res.init == false) {
                resourcesInit();
            }
        }, 2500);

        function resourcesAjaxSearch() {
            var options = $('#res-filter').serialize();

            if( rhr != null ) {
                rhr.abort();
                rhr = null;
            }

            rhr = $.ajax({
                url: ajax_url,
                timeout: 20000,
                type: "POST",
                cache: false,
                data: ({
                    action:'resource_search',
                    options: options,
                }),

                beforeSend: function() {
                    $('.ajax-resources').addClass('loading');
                    addLoader();
                },
                success: function( data ) {
                    var result = decodeJSON(data);
                    res.pages = result.more;
                    $('#resources-results').html(result.html);
                    $('#resources-pagination').html(result.pagination);
                    $('.ajax-resources').removeClass('loading');
                    addLoader(false);
                    setTimeout(function(){
                        $('#resources-results').foundation();
                    }, 300);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                    $('#res-filter select').trigger('change');
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function addLoader(action = true) {
            $('.sc-loader').remove();
            if (action == true) {
                var loaderHrml = '<div class="sc-loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>';
                $('.ajax-resources').append(loaderHrml);
            }
        }


        function getResPage(ids) {
            if( rhr != null ) {
                rhr.abort();
                rhr = null;
            }

            rhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: "POST",
                cache: false,
                data: ({
                    action:'get_res_page',
                    ids: encodeJSON(ids)
                }),

                beforeSend: function() {
                    $('.ajax-resources').addClass('loading');
                    addLoader();
                },
                success: function( data ) {
                    $('.ajax-resources').removeClass('loading');
                    $('#resources-results').html(data);
                    addLoader(false);
                    setTimeout(function(){
                        $('#resources-results').foundation();
                    }, 300);

                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        //Document Ready ENDS
    });
})(jQuery);